export default __webpack_public_path__ + "static/media/profile.9c1f9bae.png";